import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import QuickView from './QuickView';

function ShopCard({ shopID, shopImage, shopTitle, shopPrice }) {
    const [isQuickViewOpen, setQuickViewOpen] = useState(false);

    const handleCloseQuickView = () => {
        setQuickViewOpen(false); // Close the quick view modal
    };
    return (
        <>
            <div className="th-product product-grid">
                <div className="product-img">
                    <img
                        src={`/assets/img/product/${shopImage}`}
                        alt="Product"
                    />
                    <span className="product-tag">Sale</span>
                    <div className="actions">
                        <button className="icon-btn" onClick={() => setQuickViewOpen(true)}>
                            <i className="far fa-eye" />
                        </button>
                        <Link to="/cart" className="icon-btn">
                            <i className="far fa-cart-plus" />
                        </Link>
                        <Link to="/wishlist" className="icon-btn">
                            <i className="far fa-heart" />
                        </Link>
                    </div>
                </div>
                <div className="product-content">
                    <h3 className="product-title">
                        <Link to={`/shop/${shopID}`}>{shopTitle ? shopTitle : 'Beach casual-shoe'}</Link>
                    </h3>
                    <div className="woocommerce-product-rating">
                        <span className="count">(5.00 Review)</span>
                        <div
                            className="star-rating"
                            role="img"
                            aria-label="Rated 5.00 out of 5"
                        >
                            <span>
                                Rated <strong className="rating">5.00</strong> out of 5
                                based on <span className="rating">1</span> customer
                                rating
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {isQuickViewOpen && (
                <QuickView
                    shopID={shopID}
                    shopImage={shopImage}
                    shopTitle={shopTitle}
                    shopPrice={shopPrice}
                    onClose={handleCloseQuickView}
                />
            )}
        </>
    )
}

export default ShopCard
